export const Footer = () => {
  return (
    <footer class="footer">
      <p class="copyright">&copy; 2025 - Stephen Ins</p>
    </footer>
  );
};
